import React from 'react';
import PropTypes from 'prop-types';
import { CTA, Icon, ProgressBar, Text } from '../../../atoms';
import { ProgressResult, ResultsWrapper, Target, TargetMsg } from '../style';
import theme from '../../../theme';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';

const QuizResult = ({ mediaIsPhone, quiz, hideBtns, retry }) => {
  if (Object.keys(quiz)?.length <= 0) return null;

  const { quiz_passed, quiz_result } = quiz;
  const minCorrectAnswers = Math.ceil(
    quiz.quiz_minimum_percentage_required * quiz.quiz_result.length
  );
  return (
    <ResultsWrapper>
      <div className="result-msg-wrapper">
        <Icon type={quiz_passed ? 'face-smile' : 'face-frown'} size={63} />
        <div>
          <Text type="h2">
            {quiz_passed ? 'Complimenti' : 'Siamo spiacenti'}, hai risposto
            correttamente a{' '}
            {quiz_result?.filter((r) => r?.question_correct)?.length} domande su{' '}
            {quiz_result?.length}
          </Text>
          <Text type="b2">
            {quiz_passed
              ? 'Hai superato correttamente il quiz!'
              : 'Non arrenderti, continua a imparare e migliorare per ritentare il quiz'}
          </Text>
        </div>
      </div>
      <ProgressResult>
        <div className="progress-wrapper">
          <ProgressBar
            percentage={quiz.quiz_percentage_achieved * 100}
            color={theme().colors.bgSubFooter}
            bgColor="#E3E3E3"
            height={24}
          />
          <Target left={(minCorrectAnswers / quiz.quiz_result.length) * 100}>
            <Icon type="target-04" size={24} clickable={false} />
          </Target>
          <TargetMsg left={(minCorrectAnswers / quiz.quiz_result.length) * 100}>
            <Text type="b3">
              <b>Obiettivo:</b>
              <br />
              {minCorrectAnswers}
              &nbsp;risposte corrette
            </Text>
          </TargetMsg>
          <Text type="h2" className="answers min">
            0
          </Text>
          <Text type="h2" className="answers max">
            {quiz.quiz_result.length}
          </Text>
        </div>
      </ProgressResult>
      {!quiz_passed && !hideBtns && (
        <div className="btn-wrapper">
          <CTA btnText="Riprova" onClick={retry} fullsize={mediaIsPhone} />
        </div>
      )}
    </ResultsWrapper>
  );
};

QuizResult.propTypes = {
  mediaIsPhone: PropTypes.bool,
  hideBtns: PropTypes.bool,
  quiz: PropTypes.object,
  retry: PropTypes.func,
};

export default withMediaQueries(QuizResult);
